// extracted by mini-css-extract-plugin
export default {"PortfolioSummary":"styles_PortfolioSummary__rS4s8"};